import React from 'react';
import { Grid, Typography, Button } from '@material-ui/core';
import DrawerPwa from '../DrawerPwa';
import DialogBox from '../DialogBox';
import { Redux, Slices } from 'spwa-ui-library';
import { useIntl } from 'react-intl';
import { useNavigate } from '@reach/router';
import css from './index.module.scss';
const { useSelector } = Redux;
const { selectDesktop } = Slices.appSlice;

function OpenCartDialog({ setShowCartDialog }) {
  const intl = useIntl();
  const navigate = useNavigate();
  const isDesktop = useSelector(selectDesktop);

  const handlePopupClose = () => {
    setShowCartDialog(false);
  };

  const openCart = () => {
    navigate(`/${intl.locale}/cart`);
  };

  const DialogContent = (
    <Grid>
      {!isDesktop && (
        <div className={css.removeItemTitle}>
          <Typography variant={'body1'}>{intl.formatMessage({ id: 'remove_item' })}</Typography>
        </div>
      )}
      <div className={css.removeItemBody}>
        <Typography variant="body1">{intl.formatMessage({ id: 'remove_item_body' })}</Typography>
      </div>
      <div className={css.removeItemFooter}>
        <Button
          className={css.removeItemNoBtn}
          variant={'outlined'}
          color={'secondary'}
          onClick={() => {
            setShowCartDialog(false);
          }}
        >
          {intl.formatMessage({ id: 'no', defaultMessage: 'No' })}
        </Button>
        <Button
          variant={'outlined'}
          color={'primary'}
          onClick={() => {
            openCart();
          }}
        >
          {intl.formatMessage({ id: 'yes', defaultMessage: 'Yes' })}
        </Button>
      </div>
    </Grid>
  );

  return (
    <>
      {isDesktop ? (
        <DialogBox
          title={intl.formatMessage({ id: 'remove_item' })}
          titleClass={css.removeItemTitle}
          hideCloseButton={true}
          size="md"
          className={css.changeOrderModeDialog}
          isOpen={true}
          onClose={() => {
            handlePopupClose();
          }}
        >
          {DialogContent}
        </DialogBox>
      ) : (
        <DrawerPwa
          variant="temporary"
          anchor="bottom"
          hideCloseButton={true}
          open={true}
          onClose={() => {
            handlePopupClose();
          }}
        >
          {DialogContent}
        </DrawerPwa>
      )}
    </>
  );
}

export default OpenCartDialog;
